import { apiClient } from '@/core/infra_api_client'
import type { AuditLogEntry, PaginatedResponse } from '@/core/infra_types'

const BASE_PATH = 'audit'

export async function listAuditLogs(params?: {
  page?: number
  perPage?: number
  action?: string
  resourceType?: string
  actorEmail?: string
}): Promise<PaginatedResponse<AuditLogEntry>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.action) searchParams['action'] = params.action
  if (params?.resourceType) searchParams['resource_type'] = params.resourceType
  if (params?.actorEmail) searchParams['actor_email'] = params.actorEmail

  return apiClient.get<PaginatedResponse<AuditLogEntry>>(BASE_PATH, searchParams)
}
